const contributors = [
  {
    name: 'Jeremy Hutchcraft',
    title: 'Front End Developer',
    profile_img: 'https://i.imgur.com/g7gswnL.jpg',
  },
  {
    name: 'Greg DiPietro',
    title: 'Front End Developer',
    profile_img: 'https://pbs.twimg.com/profile_images/674262058226069505/43jnHbB2_400x400.jpg',
  },
  {
    name: 'Mike Griffith',
    title: 'Software Engineer',
    profile_img: 'https://avatars.githubusercontent.com/u/167782?v=4',
  },
];

export default contributors;



// WEBPACK FOOTER //
// ./app/pages/contributors/contributors.js